import {
  API,
  GraphQLQuery,
  GraphQLResult,
  GraphQLSubscription,
} from "@aws-amplify/api";
import awsmobile from "./aws-exports";
import * as types from "./API";
import * as mutations from "./graphql/mutations";
import * as queries from "./graphql/queries";
import * as subscriptions from "./graphql/subscriptions";
API.configure(awsmobile);

export type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

const execQuery = <InputType extends object | undefined, OutputType>(
  query:
    | GeneratedQuery<InputType, OutputType>
    | GeneratedMutation<InputType, OutputType>,
  variables?: InputType,
): Promise<GraphQLResult<GraphQLQuery<OutputType>>> =>
  API.graphql({
    query,
    variables,
  }) as Promise<GraphQLResult<GraphQLQuery<OutputType>>>;

const wrapMutation =
  <InputType extends object | undefined, OutputType>(
    mutation: GeneratedMutation<InputType, OutputType>,
  ) =>
  async (variables: InputType) =>
    execQuery(mutation, variables);

const subscribe = <InputType extends object | undefined, OutputType>(
  subscription: GeneratedSubscription<InputType, OutputType>,
  variables?: InputType,
) =>
  API.graphql<GraphQLSubscription<OutputType>>({
    query: subscription,
    variables,
  });

export {
  execQuery,
  mutations,
  queries,
  subscribe,
  subscriptions,
  types,
  wrapMutation,
};
